import {
  SavingsTracker,
  SavingsTrackerRequirement,
  SavingsTrackerRequirementType,
} from '@varo/graphql-schema-types';
import GetSavingsTracker from 'services/graphql/queries/GetSavingsTracker';
import { useQuery } from 'urql';

type UseSavingsTrackerResult = {
  savingTrackerData: SavingsTracker | undefined;
  directDepositData: SavingsTrackerRequirement | undefined;
  fetching: boolean;
  error: Error | null;
  refetch: () => void;
};

export const useSavingsTracker = (id: string): UseSavingsTrackerResult => {
  const [{ data, fetching, error }, refetch] = useQuery<{
    accountR2: {
      id: string;
      savingsTracker: SavingsTracker;
    };
  }>({
    query: GetSavingsTracker,
    requestPolicy: 'network-only',
    variables: { id },
  });

  const savingTrackerData = data?.accountR2?.savingsTracker;
  const directDepositData = savingTrackerData?.requirements?.find(
    (item) => item.type === SavingsTrackerRequirementType.DirectDeposit,
  );

  return {
    savingTrackerData: savingTrackerData ?? undefined,
    directDepositData: directDepositData ?? undefined,
    fetching,
    error: error ?? null,
    refetch,
  };
};
